import { useState } from "react"
import { useQuery } from "@tanstack/react-query"
import { format } from "date-fns"
import { GetAllTraining } from "../../api/Training/GetAllTraining"
import Spinner from "../../components/Shared/Spinner"
import { ChevronRightIcon } from "lucide-react"
const Training = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const limit = 6;
     const { data: TrainingData, isLoading } = useQuery({
        queryFn: () => GetAllTraining({ page: currentPage, limit }),
        queryKey: ["trainings", currentPage],
        staleTime: 0,
        refetchInterval: 0,
    });
     const training = TrainingData?.data?.trainings || [];
    const metadata = TrainingData?.data?.metaData;
     const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };
 
    return (
        <div>

                <div>
                    <div className="flex justify-between items-center py-7">
                        <h1 className="text-burntBlack font-bold text-[32px]">Training Requests</h1>
                    </div>
                    {isLoading ? (<div className="h-[50vh] flex items-center justify-center">
                        <Spinner />
                    </div>) : (
                        <div>
                                                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                            {training?.map((training) => (
                                <div
                                    key={training.id}
                                    className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow"
                                >
                                    <div className="flex justify-between items-start mb-4">
                                        <div>
                                            <h2 className="text-xl font-semibold text-gray-800">{training.companyName}</h2>
                                            <div className="flex gap-2 mt-2">
                                                <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm">
                                                    {training.industry}
                                                </span>
                                                {!training.areaOfTraining  && 
                                                    <span className={`px-3 py-1 rounded-full text-sm ${training.isTrainingNeeded ? "bg-green-100 text-green-800 " : "bg-red-100 text-red-800"}`}>
                                                        {training.isTrainingNeeded ? "Training Needed" : "Training Not Needed"}
                                                    </span>
                                                    }
                                            </div>
                                        </div>
                                    </div>

                                    <div className="space-y-2 mb-4">
                                        <p className="text-gray-600">
                                            <span className="font-medium">Training Area:</span> {training.areaOfTraining}
                                        </p>
                                        <p className="text-gray-600">
                                            <span className="font-medium">Employees:</span> {training.numberOfEmployees}
                                        </p>
                                        <p className="text-gray-600">
                                            <span className="font-medium">Budget:</span> {training.expectedBudget}
                                        </p>
                                        {training.additionalNote && (
                                            <p className="text-gray-600">
                                                <span className="font-medium">Note:</span> {training.additionalNote}
                                            </p>
                                        )}
                                    </div>
                                    <div className="border-t pt-4">
                                        <div className="flex justify-between items-start">
                                            <div>
                                                <p className="text-gray-600 text-sm">
                                                    <span className="font-medium">Contact:</span>
                                                </p>
                                                <p className="text-gray-500 text-sm">{training.contactPerson}</p>
                                                <p className="text-gray-500 text-sm">{training.email}</p>
                                                <p className="text-gray-500 text-sm">{training.phone}</p>
                                            </div>
                                            <div className="text-right">
                                                <p className="text-gray-500 text-sm">Created</p>
                                                <p className="text-gray-600 text-sm">
                                                    {format(new Date(training.createdAt), 'MMM dd, yyyy')}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                            
                        </div>
                        {!isLoading && metadata && (
                       <div className="flex justify-center items-center gap-2 mt-8 mb-6">
                           <button
                               onClick={() => handlePageChange(currentPage - 1)}
                               disabled={currentPage === 1}
                               className={`px-4 py-2 rounded-md ${
                                   currentPage === 1
                                       ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
                                       : 'bg-blue-500 text-white hover:bg-blue-600'
                               }`}
                           >
                                                              <ChevronRightIcon className="w-5 h-5 rotate-180"/>
                           </button>
                           
                           <div className="flex gap-2">
                               {[...Array(metadata.totalPages)].map((_, index) => (
                                   <button
                                       key={index + 1}
                                       onClick={() => handlePageChange(index + 1)}
                                       className={`px-4 py-2 rounded-md ${
                                           currentPage === index + 1
                                               ? 'bg-blue-500 text-white'
                                               : 'bg-gray-200 hover:bg-gray-300'
                                       }`}
                                   >
                                       {index + 1}
                                   </button>
                               ))}
                           </div>
                            <button
                               onClick={() => handlePageChange(currentPage + 1)}
                               disabled={currentPage === metadata.totalPages}
                               className={`px-4 py-2 rounded-md ${
                                   currentPage === metadata.totalPages
                                       ? 'bg-gray-200 text-gray-500 cursor-not-allowed'
                                       : 'bg-blue-500 text-white hover:bg-blue-600'
                               }`}
                           >
                               <ChevronRightIcon className="w-5 h-5"/>
                           </button>
                       </div>
                   )}

                        </div>
                    )}
                </div>
        </div>
    )
}

export default Training